import courseList from "@/controllers/course/course-list";

export default {
  extends: courseList,
}
